export default {"src":"https://webcdn.trailways.ca/_next/static/media/circle-info-light.568ecb43.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};